import React from "react";
import styled from "styled-components";
import { MediaProvider } from "../../../schemas/Media";
import { SanityImage } from "./SanityImage";
import CssCroppedImage from "../components/CssCroppedImage";
const StylableImage = React.forwardRef((props) => {
    const { media, optimized = true, crop, fit, pixelRatio, loading = "lazy", ...htmlProps } = props;
    switch (media.provider) {
        case MediaProvider.SANITY:
            return React.createElement(SanityImage, { media: media, optimized, crop, fit, pixelRatio, ...htmlProps });
        case MediaProvider.YOUTUBE:
        case MediaProvider.DDRAGON:
        case MediaProvider.WEB:
            return React.createElement(CssCroppedImage, { media: media, loading: loading, ...htmlProps });
        default: {
            const _ = media.provider;
            throw new Error(`Warning: unknown media type: ${_}`);
        }
    }
});
StylableImage.displayName = "StylableImage";
StylableImage.defaultProps = {
    "data-testid": "mediaImage",
};
export const MediaImage = styled(StylableImage) `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
//# sourceMappingURL=MediaImage.js.map